import cashierSettings from 'api/cashierSettings';

import auditLogs from './auditLogs';
import auth from './auth';
import binGroups from './binGroups';
import blacklists from './blacklists';
import cardIssuingOrganisation from './cardIssuingOrganisation';
import cashierLimits from './cashierLimits';
import cashierPaymentMethods from './cashierPaymentMethods';
import changeRule from './changeRule';
import clients from './clients';
import cms from './cms';
import countryGroups from './countryGroups';
import dashboards from './dashboards';
import data from './data';
import filters from './filters';
import hostedFieldsThemes from './hostedFieldsThemes';
import integrationBuilder from './integrationBuilder';
import invoices from './invoices';
import manualPayout from './manualPayout';
import manualTransaction from './manualTransaction';
import merchantGroups from './merchantGroups';
import merchants from './merchants';
import merchantTerminalThemes from './merchantTerminalThemes';
import metadataTemplates from './metadataTemplates';
import notification from './notification';
import notificationCenter from './notificationCenter';
import organizations from './organizations';
import paymentLinks from './paymentLinks';
import paymentMethods from './paymentMethods';
import portalUser from './portalUser';
import psp from './psp';
import reconciliation from './reconciliation';
import reports from './reports';
import resultCodes from './resultCodes';
import rolesPermissions from './rolesPermissions';
import routingRuleset from './routingRuleset';
import settlementContracts from './settlementContracts';
import sharedLink from './sharedLink';
import terminals from './terminals';
import terminalsLinks from './terminalsLinks';
import transactions from './transactions';
import users from './users';

export default {
  auditLogs,
  auth,
  binGroups,
  blacklists,
  cardIssuingOrganisation,
  cashierLimits,
  cashierPaymentMethods,
  cashierSettings,
  changeRule,
  clients,
  cms,
  countryGroups,
  dashboards,
  data,
  filters,
  hostedFieldsThemes,
  integrationBuilder,
  invoices,
  manualPayout,
  manualTransaction,
  merchantGroups,
  merchants,
  merchantTerminalThemes,
  metadataTemplates,
  notification,
  notificationCenter,
  organizations,
  paymentLinks,
  paymentMethods,
  portalUser,
  psp,
  reconciliation,
  reports,
  resultCodes,
  rolesPermissions,
  routingRuleset,
  settlementContracts,
  sharedLink,
  terminals,
  terminalsLinks,
  transactions,
  users,
};
